import { useAuth } from './useAuth';

// Модули тарифа приходят с сервера (/auth/me → features): с фазы 4 флекси-биллинга
// фичи живут в тарифе орги, а не в матрице планов (backend/services/tariff/features.js).
// Зеркала на фронте больше нет — расходиться нечему.
//
// Тарифом гейтятся только модули из TARIFF_FEATURES (сейчас — Проекты). Всё
// остальное (в т.ч. `expenses`) тарифом не режется: Расходы висят на тумблере
// организации, и hasFeature для них всегда true — как и раньше.
const TARIFF_FEATURES = ['projects'];

export function usePlan() {
  const { user } = useAuth();
  const features = user?.features || {};

  function hasFeature(feature) {
    if (!TARIFF_FEATURES.includes(feature)) return true;
    return features[feature] === true;
  }

  return {
    plan: user?.plan || 'trial',
    hasFeature,
    isPro: features.projects === true,
  };
}
